import { gql } from '@apollo/client';

const Fragments = {
  authorizationItem: gql`
    fragment authorizationItem on Authorization {
      webAuthorizationId
      name
      description
      code
      contextTypeId
      isRefined
    }
  `,
  authorizationXUserGroup: gql`
    fragment authorizationXUserGroup on AuthorizationXUserGroup {
      authorizationId
      userGroupId
      canRead
    }
  `,
  authorizationXDocumentTypeXUserGroup: gql`
    fragment authorizationXDocumentTypeXUserGroup on AuthorizationXDocumentTypeXUserGroup {
      documentStateId
      documentTypeId
      userGroupId
      authorizationId
      canRead
    }
  `,
  authorizationContextType: gql`
    fragment authorizationContextType on AuthorizationContextType {
      authorizationContextTypeId
      authorizationContextTypeCode
      authorizationContextTypeName
      refine
      documentTypeIdList
    }
  `,
  documentTypeXStateModel: gql`
    fragment documentTypeXStateModel on DocumentTypeXStateModel {
      documentTypeId
      documentTypeName
      documentStateId
      documentStateName
    }
  `
};

export default Fragments;
